import React, { useEffect, useState } from "react";
import Row from "../components/Row";
import Column from "../components/Column";
import TitleUnderlined from "../components/TitleUnderlined";
import Button from "../components/Button";
import Utils from "../tools/Utils";
import { useNavigate } from 'react-router-dom';
import { RoutesWeb } from "../tools/RoutesWeb";
import APIInterface from "../tools/APIInterface";
require('../style/views/loginView.scss');

const LoginView = () => {
    const token = localStorage.getItem('tokenGroup');
    const [wasValidated, setWasValidated] = useState(false);
    const [data, setData] = useState({email: null, password: null});
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    
    useEffect(() => {
        if(token){
            navigate(RoutesWeb.REGISTER_GROUP);
        }
    }, [token, navigate]);
    
    const handleSubmit = (e) => {
        if(e.target.checkValidity() === false) {
            e.preventDefault();
            e.stopPropagation();
            Utils.Toast.fire({
                icon: 'error',
                text: 'Faltan campos obligatorios por llenar'
            });
            setWasValidated('was-validated');
        } else {
            e.preventDefault();
            e.stopPropagation();
            if(!isLoading){
                setIsLoading(true);
                APIInterface.login(data)
                .then((response) => {
                    localStorage.setItem('tokenGroup', response.data.token);
                    localStorage.setItem('userGroup', response.data.user.name);
                    navigate(RoutesWeb.REGISTER_GROUP);
                })
                .catch((error) => {
                    console.error(error);
                });
            }
        }
    }
    const handleData = (e) => {
        let newData = data;
        newData[e.target.name] = e.target.value;
        setData(newData);
    }

    return (
        <div className="pt-5" id="loginView">
            <br />
            <br />
            <Row>
                <Column className="col-md-6">
                    <TitleUnderlined>Registro de <span className="embercom_overlined">Grupo</span></TitleUnderlined>
                    <br />
                    <br />
                    <p>Inicia tu sesión como administrador.</p>
                    <form onSubmit={handleSubmit} className={`needs-validation ${wasValidated}`} noValidate>
                        <div className="form-group">
                            <label htmlFor="email">Usuario</label>
                            <input type="email" required id="email" name="email" className="form-control" onChange={handleData} />
                        </div>
                        <div className="form-group">
                            <label htmlFor="password">Contraseña</label>
                            <input type="password" required id="password" name="password" className="form-control" onChange={handleData} />
                        </div>
                        <br />
                        <br />
                        <Button disabled={isLoading}>
                            Iniciar sesión 
                            {isLoading ?
                                <div className="spinner-border" role="status" style={{height: '15px',
                                    width: '15px',
                                    fontSize: '10px',
                                    marginLeft: '10px'}}>
                                    {/* <span className="sr-only">Loading...</span> */}
                                </div>
                            :
                            <img src={require('../assets/arrow_next.png')} alt="arrowNext" style={{marginLeft: '2rem'}} />
                            }
                        </Button>
                    </form>
                </Column>
                <Column className="col-md-6 d-flex justify-content-center align-items-start">
                    <img src={require('../assets/img3min.png')} alt="Img" style={{width: '100%', maxWidth: '430px'}} />
                </Column>
            </Row>
        </div>
    )



}

export default LoginView;
